export default __webpack_public_path__ + "static/media/logout-filled.12e37732.svg";